import AbsComponent from '../../common/components/AbsComponent';

/**
 * Sub1 class
 * @category testApp
 */
class ProfileImg extends AbsComponent{
    constructor(_store={}){
        super(_store);
        if(_store.data.config.isMyCharacter) {
            window.characterList = this.init({
                characterUpload: {
                    createToken: _store.data.config.apiDomain + '/web/v2/characters/profile/file/token',
                    savePermenant: _store.data.config.apiDomain + '/web/v2/characters/profile/file/save',
                    profileImageSave: _store.data.config.apiDomain + '/web/v2/characters/profile/image/register',
                    isProfileUpload: true
                }
            });
        }
    }

    init(options){
        let defs = {
            characterUpload: {}
        };
        this.options = $.extend({}, defs, options);
        this.createCharacterUpload();
        this.bindEvents();
    }

    createCharacterUpload(){
        this.characterUpload = new ui.ncUpload( this.options.characterUpload );
    }

    bindEvents(){
        this.characterUpload.onProfileComplete.add( ( data )=>{
            location.reload(); //cnb도 갱신되어야 함
        }, this );
    }
}

export default ProfileImg;